import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Pay_Center from './components/Pay_Center';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import UserRoles from "../../../../constants/UserRoles";

export default ({match, regions,roles}) => (

	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Pay_Center regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
